<template>
  <div class="phases">
    <phase-item :phase-data="phase1" :hrn-color-1="8" :hrn-color-2="7">
      <template #title>1ª Fase</template>
      <template #step-link>
        <router-link
          :to="{ name: 'action-plan-form', params: { step: 1 } }"
          class="btn btn-success"
          >Ver</router-link
        >
      </template>
      <template #description>
        <div>Resultado Risco HRN de 500 a 1000 - Extremo</div>
        <div>Resultado Risco HRN superior a 1000 - Inaceitável</div>
      </template>
    </phase-item>

    <phase-item
      :phase-data="phase2"
      :hrn-color-1="6"
      :hrn-color-2="5"
      :show-footer="true"
    >
      <template #title>2ª Fase</template>
      <template #step-link>
        <router-link
          :to="{ name: 'action-plan-form', params: { step: 2 } }"
          class="btn btn-success"
          >Ver</router-link
        >
      </template>
      <template #description>
        <div>Resultado Risco HRN de 50 a 100 - Alto</div>
        <div>Resultado Risco HRN de 100 a 500 - Muito Alto</div>
      </template>
    </phase-item>

    <phase-item
      :phase-data="phase3"
      :hrn-color-1="3"
      :hrn-color-2="1"
      :show-footer="true"
    >
      <template #title>3ª Fase</template>
      <template #step-link>
        <router-link
          :to="{ name: 'action-plan-form', params: { step: 3 } }"
          class="btn btn-success"
          >Ver</router-link
        >
      </template>
      <template #description>
        <div>Resultado Risco HRN de 00 a 05 - Aceitável/Muito Baixo</div>
        <div>Resultado Risco HRN de 05 a 50 - Baixo/Significante</div>
      </template>
    </phase-item>
  </div>
</template>

<script>
  import { computed } from '@vue/runtime-core'

  import PhaseItem from './PhaseItem'
  import { useStore } from 'vuex'

  export default {
    setup() {
      const store = useStore()
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)

      return {
        selected_order_of_service,
      }
    },
    components: {
      PhaseItem,
    },
    data() {
      return {
        phase1: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgeted: 0,
          budgetedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
        phase2: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgeted: 0,
          budgetedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
        phase3: {
          total: 0,
          delegated: 0,
          delegatedPercentage: 0,
          scheduled: 0,
          scheduledPercentage: 0,
          budgeted: 0,
          budgetedPercentage: 0,
          projected: 0,
          projectedPercentage: 0,
          inAdequacy: 0,
          inAdequacyPercentage: 0,
          concluded: 0,
          concludedPercentage: 0,
          homologated: 0,
          homologatedPercentage: 0,
        },
      }
    },
    methods: {
      loadData() {
        this.axios
          .get(
            `/api/action-plan/get-total-by-phase?order_of_service_id=${this.selected_order_of_service.id}`,
          )
          .then(({ data }) => {
            this.phase1 = { ...data.phase1 }
            this.phase2 = { ...data.phase2 }
            this.phase3 = { ...data.phase3 }
          })
          .catch((error) => {
            console.log(error)
          })
      },
    },
    mounted() {
      this.loadData()
    },
    watch: {
      selected_order_of_service() {
        this.loadData()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .phases {
    display: flex;
    justify-content: space-between;
  }
</style>
